export const iconFontAwesomeDisasterCrisisHouseChimneyCrack = (
	<i className="fa-solid fa-house-chimney-crack"></i>
);
